import addUserFooterButtonsUrl from './addUserFooterButtons.html';
export default {
  controllerAs: 'ctrl',
  templateUrl: addUserFooterButtonsUrl,
  bindings: {
    form: '<',
    user: '<',
    submit: '&',
    cancel: '&',
  },
};
